module.exports = __webpack_public_path__ + "static/icons/icon-search--bold-0ae59e8c6f70496d9d8b8fdce2bad41d.svg";